import { api } from '@/lib/api'
import { defaultPaginationMeta, parseMasterCatalogResponse } from '@/lib/api/masterCatalog'

/** @typedef {import('@/types/api').Chair} Chair */

export const CHAIR_TYPE_OPTIONS = [
  { value: 'hair', label: 'Hair' },
  { value: 'nail', label: 'Nail' },
  { value: 'spa', label: 'Spa' },
]

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<{ items: Chair[], meta: import('@/types/api').PaginationMeta }>}
 */
export async function fetchChairsPage(params = {}) {
  const { data } = await api.get('/masters/chairs', { params })
  const parsed = parseMasterCatalogResponse(data, 'chairs')
  return {
    items: parsed.items,
    meta: defaultPaginationMeta(parsed.meta ?? {}),
  }
}

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<Chair[]>}
 */
export async function fetchChairsList(params = {}) {
  const { data } = await api.get('/masters/chairs', { params })
  return data.data.chairs
}

/**
 * @returns {Promise<Chair[]>}
 */
export async function fetchChairs() {
  return fetchChairsList()
}

/**
 * @param {number} chairId
 * @returns {Promise<Chair>}
 */
export async function fetchChair(chairId) {
  const { data } = await api.get(`/masters/chairs/${chairId}`)
  return data.data.chair
}

/**
 * @param {Partial<Chair>} payload
 * @returns {Promise<Chair>}
 */
export async function createChair(payload) {
  const { data } = await api.post('/masters/chairs', payload)
  return data.data.chair
}

/**
 * @param {number} chairId
 * @param {Partial<Chair>} payload
 * @returns {Promise<Chair>}
 */
export async function updateChair(chairId, payload) {
  const { data } = await api.put(`/masters/chairs/${chairId}`, payload)
  return data.data.chair
}
